
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-test-claude-api-key",
      function () {
        return require("private-next-pages/how-to-test-claude-api-key.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-test-claude-api-key"])
      });
    }
  